import { t } from "@/i18n-js/instance";
import { Icon } from "@circle-react/components/shared/Icon";
import { Typography } from "@circle-react-shared/uikit/Typography";
import { CIRCLE_COMMUNITY_LIVE_EVENTS } from "../constants";
import { useListEvents } from "../hooks/useListEvents";
import type { Event } from "../types/event";
import { EventItem } from "./EventItem";
import { EventsDateDivider } from "./EventsDateDivider";
import { HelpWidgetLayout } from "./common/HelpWidgetLayout";
import { ListViewSkeletonLoader } from "./common/ListViewSkeletonLoader";

export const EventsListView = () => {
  const { isLoading, data } = useListEvents();

  if (isLoading) {
    return <ListViewSkeletonLoader />;
  }

  const events = data?.records || [];

  return (
    <HelpWidgetLayout className="scrollbar-hide bg-secondary flex h-full flex-col overflow-y-auto">
      {events.map((event: Event, index: number) => (
        <div key={event.id}>
          <EventsDateDivider
            current={event.starts_at}
            previous={events[index - 1]?.starts_at}
          />
          <div className="px-4">
            <EventItem key={event.id} event={event} showArrowIcon={false} />
          </div>
        </div>
      ))}
      <div className="p-4">
        <a
          href={CIRCLE_COMMUNITY_LIVE_EVENTS}
          target="_blank"
          rel="noopener noreferrer"
          className="see-more-news border-disabled flex h-8 items-center justify-center gap-1 self-stretch rounded-3xl border px-4"
        >
          <Typography.LabelSm color="text-primary" weight="medium">
            {t("support_widget.news.see_more")}
          </Typography.LabelSm>
          <Icon type="share-support-widget" useWithFillCurrentColor size={16} />
        </a>
      </div>
    </HelpWidgetLayout>
  );
};
